import { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

const ScrollToFormButton: FC = () => {
    const [visible, setVisible] = useState(false);
    const location = useLocation();
    const isLegalPage = location.pathname === '/legal';

    useEffect(() => {
        const onScroll = () => {
            setVisible(window.scrollY > 400);
        };
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const handleClick = () => {
        if (isLegalPage) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            const el = document.getElementById('form');
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    };

    if (!visible) return null;

    return <StyledButton type="button" onClick={handleClick} />;
};

const StyledButton = styled.button`
    position: fixed;
    right: 24px;
    top: 50%;
    transform: translateY(-50%);
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: none;
    background: var(--color-primary-green);
    box-shadow: var(--shadow-main);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 30;

    &::before {
        content: '';
        display: block;
        width: 16px;
        height: 16px;
        border-style: solid;
        border-width: 0 3px 3px 0;
        border-color: var(--color-text-white);
        transform: rotate(-135deg); /* стрелка вверх */
        margin-top: 8px;
    }

    @media (max-width: 768px) {
        right: 16px;
        width: 40px;
        height: 40px;
    }
`;

export default ScrollToFormButton;


